export default "__VITE_ASSET__D15bqTX7__"